import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { TermsComponent } from '../models/terms/terms.component';



@NgModule({
  declarations: [HeaderComponent,FooterComponent, TermsComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports:[HeaderComponent,FooterComponent]
})

export class LayoutsModule { }
